import React, {Component} from 'react';
import { connect } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import classes from './PatternSearchBar.module.css';
import AuthorInput from "../UI/AuthorInput/AuthorInput";
import { withStyles } from '@material-ui/core/styles';
import cyan from "@material-ui/core/colors/cyan";
import blue from "@material-ui/core/colors/blue";
import Form from "react-bootstrap/Form";
import GameInput from "../UI/GameInput/GameInput";
import SearchOrderInput from "../UI/SearchOrderInput/SearchOrderInput";
import Row from "react-bootstrap/Row";
import ManualSearchBar from "../ManualSearchBar/ManualSearchBar";
import PatternConditionInput from "../UI/PatternConditionInput/PatternConditionInput";
import PatternConstraintInput from "../UI/PatternConstraintInput/PatternConstraintInput";
import PatternConsequenceInput from "../UI/PatternConsequenceInput/PatternConsequenceInput";
import ImprovedGroupInput from "../UI/GroupInput/ImprovedGroupInput";
import ImprovedKeywordInput from "../UI/KeywordsInput/ImprovedKeywordInput";

// If set to false it will work on every keystroke, if true it will search manually.
// This was created due to server constraints. It also might be a good idea to move it to configs.js
const setManualSearch = true;

class PatternSearchBar extends Component {

    state = {
        showOnlyExamples: false,
    };

    filterByExercise = (event) => {
        this.setState({ ...this.state, [event.target.name]: event.target.checked });
        const new_order = (event.target.checked ? 'pattern_exercise' : 'pattern_name');
        this.props.updateOrderBy(new_order);
        this.props.updatePage(0);
        this.props.closePatternDetails(null);

    };

    CustomSwitch = withStyles({
        switchBase: {
            color: blue[50],
            '&$checked': {
                color: cyan[500],
            },
            '&$checked + $track': {
                backgroundColor: cyan[500],
            },
        },
        checked: {},
        track: {},
    })(Switch);

    render () {
        const patternNameSearchBar = setManualSearch ?
            <ManualSearchBar currentSearchFilter={this.props.pattern_name_filter} updateCurrentFilter={this.props.updatePatternNameFilter}/>
            : <Form.Control
                type="text"
                placeholder="Enter a pattern name."
                value={this.props.pattern_name_filter ?? ""}
                onChange={(event) => {
                    this.props.updatePatternNameFilter(event.target.value);
                    this.props.updatePage(0);
                }}
            />

        const designProblemSearchBar = setManualSearch ?
            <ManualSearchBar currentSearchFilter={this.props.design_problem_filter} updateCurrentFilter={this.props.updateDesignProblemFilter}/>
            : <Form.Control
                type="text"
                placeholder="Enter words that appear in a design problem."
                value={this.props.design_problem_filter ?? ""}
                onChange={(event) => {
                    this.props.updateDesignProblemFilter(event.target.value, true);
                    this.props.updatePage(0);
                }}
            />

        const descriptionSearchBar = setManualSearch ?
            <ManualSearchBar currentSearchFilter={this.props.description_filter} updateCurrentFilter={this.props.updateDescriptionFilter}/>
            : <Form.Control
                type="text"
                placeholder="Enter words that appear in a pattern description."
                value={this.props.description_filter ?? ""}
                onChange={(event) => {
                    this.props.updateDescriptionFilter(event.target.value, true);
                    this.props.updatePage(0);
                }}
            />

        return (
            <header className={classes.PatternSearchBar}>
                <section>
                    <div className="card">
                        <h4 className={"card-header " + classes.SearchHeader}
                            onClick={this.props.toggleSearch}>{this.props.headerText}</h4>
                        <div className="card-body">
                            <div className="cardText">
                                <div className={classes.SerchRow} style={{marginBottom: 8}}>
                                    <Row>
                                        <div className='col-sm-6'>
                                            <div className={classes.SearchCount}>
                                                {this.props.patternsCount.count.toLocaleString() + " patterns match this search."}
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <span style={{
                                                display: 'inline-flex',
                                                width: '100%',
                                                alignItems: 'center',
                                                justifyContent: "right"
                                            }}>
                                                <span style={{whiteSpace: "nowrap"}}>Order by: </span>
                                                <SearchOrderInput orderFlag={this.props.order_by}
                                                                  updatOrderBy={this.props.updateOrderBy}/>
                                            </span>
                                        </div>
                                    </Row>
                                </div>
                                <div className={classes.SerchRow}>
                                    Pattern Name
                                    {patternNameSearchBar}
                                </div>
                                <div className={classes.SerchRow}>
                                    Design Problem
                                    {designProblemSearchBar}
                                </div>
                                <div className={classes.SerchRow}>
                                    Pattern Description
                                    {descriptionSearchBar}
                                </div>
                                <div className={classes.SerchRow}>
                                    Authors
                                    <AuthorInput
                                        userId={null}
                                        authors_filter={this.props.authors_filter}
                                        authorsUpdate={this.props.updateAuthorsFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        selectorText={"Select authors for filtering the pattern search."}
                                        authorsArr={this.props.authorsArr}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Group
                                    <ImprovedGroupInput
                                        groupsFilter={this.props.groups_filter}
                                        groupsUpdate={this.props.updateGroupsFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        placeholderText={"Select groups for filtering the pattern search."}
                                        optionsArr={this.props.groupsArr}
                                        excludeInactiveGroups={true}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Keywords
                                    <ImprovedKeywordInput
                                        keywordsFilter={this.props.keywords_filter}
                                        keywordsUpdate={this.props.updateKeywordsFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        optionsArr={this.props.keywordsArr}
                                        placeholderText={"Select keywords for filtering the pattern search"}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Conditions
                                    <PatternConditionInput
                                        pattern_condition_filter={this.props.conditions_filter}
                                        patternConditionsUpdate={this.props.updateConditionsFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        pattern_conditions={this.props.conditionsArr}
                                        selectorText={"Select conditions for filtering the pattern search."}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Constraints
                                    <PatternConstraintInput
                                        pattern_constraint_filter={this.props.constraints_filter}
                                        patternConstraintsUpdate={this.props.updateConstraintsFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        pattern_constraints={this.props.constraintsArr}
                                        selectorText={"Select constraints for filtering the pattern search."}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Consequences
                                    <PatternConsequenceInput
                                        pattern_consequence_filter={this.props.consequences_filter}
                                        patternConsequencesUpdate={this.props.updateConsequencesFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        pattern_consequences={this.props.consequencesArr}
                                        selectorText={"Select consequences for filtering the pattern search."}
                                    />
                                </div>
                                <div className={classes.SerchRow}>
                                    Example Games
                                    <GameInput
                                        games_filter={this.props.example_games_filter}
                                        gamesUpdate={this.props.updateExampleGamesFilter}
                                        updatePage={this.props.updatePage}
                                        closePatternDetails={this.props.closePatternDetails}
                                        selectorText={"Select example games for filtering the pattern search."}
                                        gamesArr={this.props.gamesArr}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </header>
        );
    }
}

const mapStateToProps = state => {
    return {
        authors_filter: state.patternLibrary.authors_filter,
        groups_filter: state.patternLibrary.groups_filter,
        keywords_filter: state.patternLibrary.keywords_filter,
        conditions_filter: state.patternLibrary.conditions_filter,
        constraints_filter: state.patternLibrary.constraints_filter,
        consequences_filter: state.patternLibrary.consequences_filter,
        pattern_name_filter: state.patternLibrary.pattern_name_filter,
        description_filter: state.patternLibrary.description_filter,
        design_problem_filter: state.patternLibrary.design_problem_filter,
        example_games_filter: state.patternLibrary.example_games_filter,
        order_by: state.patternLibrary.order_by
    }
};

export default connect(mapStateToProps)(PatternSearchBar);